<template>
    <v-container fluid>
        <div>
            <v-row>
                <v-col class="pl-5">
                    <v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="lockClick(null)">
                        <v-icon small>fa-lock</v-icon>&nbsp;{{ $t('buttons.lock') }}
                    </v-btn>
                    <v-btn v-if="!inEditMode" class="ml-2 mr-2" color="primary" @click="editClick()">
                        <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                    </v-btn>
                    <v-btn class="mr-2" @click="backClick">
                        <v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
                    </v-btn>
                </v-col>
            </v-row>
        </div>
        <v-row>
            <v-col cols="12" v-if="targetCurrency != null">
                <PlacementExpensesTable
                    :inEditMode="inEditMode"
                    :placement="placement"
                    :type="1"
                    :agFeeReadOnly="agencyFeeReadOnly"
                    :targetCurrency="targetCurrency"
                ></PlacementExpensesTable>
            </v-col>
            <v-col cols="12" v-if="targetCurrency != null">
                <PlacementExpensesTable
                    :inEditMode="inEditMode"
                    :placement="placement"
                    :type="2"
                    :agFeeReadOnly="agencyFeeReadOnly"
                    :targetCurrency="targetCurrency"
                ></PlacementExpensesTable>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PlacementExpensesTable from './PlacementExpensesTable.vue';
export default {
    name: 'PlacementExpenses',
    components: {PlacementExpensesTable},
    data: function () {
        return {
            initialLoad: false,
            lockKey: 'project-expenses',
            lockTimer: null,
            targetCurrency: null,
            agencyFeeReadOnly: false,
        };
    },
    props: ['placement', 'inEditMode'],
    methods: {
        lockClick() {
            this.$emit('edit');
        },
        editClick() {
            this.$emit('edit');
        },
        removeLock() {
            let vm = this;
            vm.$emit('edit');
            clearInterval(vm.lockTimer);
            this.$removeLock(this, this.lockKey + '|' + this.placement.id);
        },
        backClick() {
            this.$router.go(-1);
        },
    },
    beforeRouteLeave(to, from, next) {
        if (this.inEditMode) {
            let vm = this;
            this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                if (result) {
                    if (vm.lockTimer !== null) clearInterval(this.lockTimer);
                    this.$removeLock(this, this.lockKey + '|' + this.placement.id);
                    next(true);
                } else {
                    next(false);
                }
            });
        } else {
            next(true);
        }
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        } else {
            let vm = this;
            this.$APICall('get', 'expense-data/' + this.placement.maritime_object_id, {}, (data, success) => {
                if (success) {
                    vm.targetCurrency = JSON.parse(JSON.stringify(data.target_currency));
                    if (vm.targetCurrency == null) {
                        vm.$alert(
                            vm
                                .$t('alerts.createWageTemplateBeforeAddingExpenses')
                                .split('%name%')
                                .join(JSON.parse(JSON.stringify(data.name))),
                        );
                    } else {
                        vm.agencyFeeReadOnly = JSON.parse(JSON.stringify(data.ag_fee_read_only));
                    }
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        }
    },
};
</script>

<style scoped></style>
